import user from './user';
import permits from './permits';
import vehicles from './vehicles';
import userImport from './import';
import guestParkings from './guestParkings';
import parkingSpots from './parkingSpots';

export default {
  namespaced: true,
  modules: {
    user,
    permits,
    vehicles,
    userImport,
    guestParkings,
    parkingSpots,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js